import { defineStore } from 'pinia'
import { StoreHelper } from '../../helpers/storeHelper'

export const useOAuthIntegratorStore = defineStore('oAuthIntegrator', {
  state: () => ({
    oAuthIntegrators: [] as any[]
  }),
  actions: {
    async findAllOAuthIntegrators({ headers, url }: { headers?: any, url?: string }) {
      const { findAll } = StoreHelper.loadRootState()
      const result = await findAll({ headers, url })
      if (result.total > 0) {
        this.oAuthIntegrators = result.data
      } else {
        throw new Error('Failed to findAllOAuthIntegrators.')
      }
    },
    async renewToken({ headers, url }: { headers?: any, url?: string }) {
      const { findAll } = StoreHelper.loadRootState()
      await findAll({ headers, url })
    }
  }
})
